// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyProjects-page-zQSvr {
  --red: #e8232b;
  --red-d: #c2151c;
  --ink: #0f1214;
  --muted: #5a6168;
  --line: #e7e9ec;
  --bg: #f7f8f9;
  --green: #16a34a;
  --teal: #0f766e;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  color: #0f1214;
  color: var(--ink);
  background: #f7f8f9;
  background: var(--bg);
  min-height: 100vh;
}

.MyProjects-wrap-RXCJs {
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 24px;
}

/* TOP BAR */

.MyProjects-topbar-qX3Uw {
  background: #fff;
  border-bottom: 1px solid var(--line);
  position: sticky;
  top: 0;
  z-index: 20;
}

.MyProjects-brandRow-D9sfk {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  gap: 12px;
  padding: 16px 0;
}

.MyProjects-eyebrow-alumW {
  display: inline-block;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--red);
}

.MyProjects-body-vEeR7 { padding: 28px 0 64px; }

/* LOADING (branded spinner — never a blank screen) */

.MyProjects-loading-kJv5Q {
  padding: 56px 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 14px;
  color: var(--muted);
  font-weight: 700;
}

.MyProjects-loadingLabel-lFwqB { font-size: 14px; }

.MyProjects-spinner-gSLus {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: 3px solid #f0d6d7;
  border-top-color: var(--red);
  -webkit-animation: MyProjects-mpSpin-OPIsB 0.7s linear infinite;
          animation: MyProjects-mpSpin-OPIsB 0.7s linear infinite;
}

@-webkit-keyframes MyProjects-mpSpin-OPIsB {
  to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
}

@keyframes MyProjects-mpSpin-OPIsB {
  to { -webkit-transform: rotate(360deg); transform: rotate(360deg); }
}

.MyProjects-headRow-U49wz {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.MyProjects-h1-wdPlm {
  font-size: clamp(24px, 3.6vw, 34px);
  line-height: 1.1;
  font-weight: 800;
  margin: 0 0 6px;
}

.MyProjects-sub-qEv4_ {
  font-size: 15px;
  color: var(--muted);
  margin: 0;
  line-height: 1.55;
  max-width: 640px;
}

/* GRID + PROJECT CARDS */

.MyProjects-grid-j2laI {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 18px;
}

.MyProjects-card-OWdYt {
  text-align: left;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 18px 20px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 10px;
  -webkit-transition: border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  transition: border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  transition: box-shadow .15s, transform .15s, border-color .15s;
  transition: box-shadow .15s, transform .15s, border-color .15s, -webkit-box-shadow .15s, -webkit-transform .15s;
  font: inherit;
  color: inherit;
}

.MyProjects-card-OWdYt:hover {
  -webkit-box-shadow: 0 14px 34px rgba(15, 18, 20, 0.10);
          box-shadow: 0 14px 34px rgba(15, 18, 20, 0.10);
  -webkit-transform: translateY(-2px);
      -ms-transform: translateY(-2px);
          transform: translateY(-2px);
  border-color: #d7dadf;
}

.MyProjects-cardTop-jyx1x { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; gap: 8px; }

.MyProjects-catPill-_t96I {
  display: inline-block;
  background: #fff0ef;
  color: var(--red-d);
  font-weight: 800;
  font-size: 12px;
  letter-spacing: .02em;
  padding: 5px 12px;
  border-radius: 999px;
}

/* RECEIVED-QUOTES BADGE — prominent pill on each project card; shown only N>0.
   The actionable "N quotes received" counter that increments as pros submit. */

.MyProjects-quotesBadge-ONKOV {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -ms-flex-item-align: start;
      align-self: flex-start;
  gap: 6px;
  margin: 2px 0 0;
  background: #e7f8ee;
  color: var(--green);
  font-weight: 800;
  font-size: 12px;
  letter-spacing: .02em;
  padding: 5px 12px;
  border-radius: 999px;
}

.MyProjects-quotesBadge-ONKOV::before {
  content: '';
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--green);
}

.MyProjects-cardTitle-qQcFj { font-size: 18px; font-weight: 800; margin: 0; line-height: 1.25; }

.MyProjects-cardMetaRow-DBcFJ { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; gap: 14px; -webkit-box-align: center; -ms-flex-align: center; align-items: center; }

.MyProjects-cardMeta-MzpzL {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  font-size: 13.5px;
  color: var(--muted);
  font-weight: 600;
}

.MyProjects-cardMeta-MzpzL svg { width: 16px; height: 16px; color: var(--ink); opacity: .55; }

.MyProjects-cardFoot-emXDS {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  border-top: 1px solid var(--line);
  padding-top: 12px;
  margin-top: 2px;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.MyProjects-cardRef-ZLDlQ { font-size: 12.5px; color: var(--muted); font-weight: 700; display: -webkit-inline-box; display: -ms-inline-flexbox; display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 6px; }

.MyProjects-cardRef-ZLDlQ svg { width: 15px; height: 15px; opacity: .55; }

.MyProjects-cardCta-ZTBja { font-size: 14px; font-weight: 800; color: var(--red); }

/* STATUS PILLS (project + quote) */

.MyProjects-statusPill-d9ygy {
  font-size: 11.5px; font-weight: 800; letter-spacing: .03em;
  padding: 5px 11px; border-radius: 999px;
  background: var(--bg); color: var(--muted);
  text-transform: uppercase;
  white-space: nowrap;
}

.MyProjects-st_draft-vY5_c { background: #eef0f2; color: #5a6168; }

.MyProjects-st_published-_MuEL, .MyProjects-st_quoted-vAfms { background: #e7f0ff; color: #1d4ed8; }

.MyProjects-st_selected-ORFy0 { background: #e7f8ee; color: var(--green); }

.MyProjects-st_contracted-bnNSf { background: #e7f8ee; color: var(--teal); }

.MyProjects-st_closed-TnFBu { background: #eef0f2; color: #5a6168; }

.MyProjects-st_cancelled-HqnUb { background: #fff0ef; color: var(--red-d); }

/* EMPTY STATE */

.MyProjects-empty-gs0cA {
  background: #fff;
  border: 1px dashed #d7dadf;
  border-radius: 20px;
  padding: 48px 24px;
  text-align: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.MyProjects-emptyImg-prMGZ { width: 120px; height: auto; margin: 0 auto 12px; display: block; }

.MyProjects-emptyTitle-Dpqw6 { font-size: 20px; font-weight: 800; margin: 0 0 8px; }

.MyProjects-emptyBody-wxXFA { font-size: 15px; color: var(--muted); max-width: 440px; margin: 0 auto; line-height: 1.55; }

/* ALERTS */

.MyProjects-alertErr-Zmmu_, .MyProjects-alertNotice-hejO7 {
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 16px;
  line-height: 1.45;
}

.MyProjects-alertErr-Zmmu_ { background: #fff0ef; color: var(--red-d); border: 1px solid #f6c9c7; }

.MyProjects-alertNotice-hejO7 { background: #eef6ff; color: #1d4ed8; border: 1px solid #cfe0fb; }

/* BUTTONS */

.MyProjects-btn-I4tlV {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: var(--red);
  color: #fff;
  border: none;
  font-weight: 800;
  font-size: 15px;
  padding: 12px 22px;
  border-radius: 12px;
  cursor: pointer;
  text-decoration: none;
  -webkit-transition: background .15s;
  transition: background .15s;
}

.MyProjects-btn-I4tlV:hover { background: var(--red-d); }

.MyProjects-btn-I4tlV:disabled { opacity: .55; cursor: default; }

.MyProjects-btnGhost-xi7Qr {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  background: #fff;
  color: var(--ink);
  border: 1px solid var(--line);
  font-weight: 800;
  font-size: 14px;
  padding: 10px 18px;
  border-radius: 12px;
  cursor: pointer;
  text-decoration: none;
}

.MyProjects-btnGhost-xi7Qr:hover { border-color: #c9ccd1; }

.MyProjects-btnGhost-xi7Qr:disabled { opacity: .55; cursor: default; }

.MyProjects-linkBtn-JTtVP {
  background: none; border: none; color: var(--muted);
  font-weight: 700; font-size: 14px; cursor: pointer;
  padding: 6px 8px;
}

.MyProjects-linkBtn-JTtVP:hover { color: var(--ink); }

.MyProjects-linkBtn-JTtVP:disabled { opacity: .55; cursor: default; }

.MyProjects-backBtn-UqKBC {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--muted);
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  margin-bottom: 14px;
}

.MyProjects-backBtn-UqKBC:hover { color: var(--ink); }

.MyProjects-backBtn-UqKBC svg { width: 18px; height: 18px; }

/* DETAIL HEAD */

.MyProjects-detailHead-MMpI4 { margin-bottom: 22px; }

.MyProjects-detailHead-MMpI4 .MyProjects-catPill-_t96I { margin-bottom: 10px; }

.MyProjects-detailScope-ikKES {
  font-size: 15px; color: #2a2f34; line-height: 1.6;
  margin: 12px 0 0; max-width: 760px; white-space: pre-line;
}

.MyProjects-detailFacts-Ycn7b { display: -webkit-box; display: -ms-flexbox; display: flex; -ms-flex-wrap: wrap; flex-wrap: wrap; gap: 8px; margin-top: 14px; }

.MyProjects-factChip-RGW3F {
  background: #fff; border: 1px solid var(--line); border-radius: 999px;
  padding: 6px 12px; font-size: 13px; font-weight: 700; color: var(--muted);
}

/* COMPARE HEAD */

.MyProjects-compareHead-JIZ0x {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin: 0 0 18px;
}

.MyProjects-compareTitle-HUHAF { font-size: 22px; font-weight: 800; margin: 0 0 6px; }

.MyProjects-privacyNote-RuDOS {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start; gap: 7px;
  font-size: 13px; color: var(--muted); margin: 0; line-height: 1.5;
  max-width: 560px;
}

.MyProjects-privacyNote-RuDOS svg { width: 16px; height: 16px; color: var(--teal); -ms-flex-negative: 0; flex-shrink: 0; margin-top: 1px; }

.MyProjects-sortRow-XfyMK { display: -webkit-inline-box; display: -ms-inline-flexbox; display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 8px; }

.MyProjects-sortLabel-sG9pE { font-size: 13px; font-weight: 700; color: var(--muted); }

.MyProjects-sortSelect-qzGUe {
  border: 1px solid var(--line); border-radius: 10px;
  padding: 9px 12px; font: inherit; font-size: 14px; font-weight: 700;
  background: #fff; color: var(--ink); cursor: pointer;
}

.MyProjects-sortSelect-qzGUe:focus { outline: none; border-color: var(--red); -webkit-box-shadow: 0 0 0 3px rgba(232,35,43,.12); box-shadow: 0 0 0 3px rgba(232,35,43,.12); }

/* COMPARE GRID + QUOTE CARDS */

.MyProjects-compareGrid-gGVdS {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 18px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
}

.MyProjects-quoteCard-cBDFN {
  position: relative;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 18px;
  padding: 20px 20px 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  gap: 14px;
}

.MyProjects-quoteCardBest-XNIe_ { border-color: var(--green); -webkit-box-shadow: 0 10px 26px rgba(22,163,74,.10); box-shadow: 0 10px 26px rgba(22,163,74,.10); }

.MyProjects-bestBadge-g3wqx {
  position: absolute; top: -11px; left: 18px;
  background: var(--green); color: #fff;
  font-size: 11px; font-weight: 800; letter-spacing: .03em;
  padding: 4px 11px; border-radius: 999px; text-transform: uppercase;
}

.MyProjects-qHead-XzQoG { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; gap: 12px; }

.MyProjects-qCompany-cKoEM { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 12px; }

.MyProjects-qAvatar-mJQAI {
  width: 42px; height: 42px; border-radius: 12px;
  background: #fff0ef; color: var(--red);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.MyProjects-qAvatar-mJQAI svg { width: 22px; height: 22px; }

.MyProjects-qCompanyName-yb8xf { display: block; font-size: 15.5px; font-weight: 800; line-height: 1.2; }

.MyProjects-qVerified-kymz1 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 4px;
  font-size: 12px; font-weight: 700; color: var(--green); margin-top: 2px;
}

.MyProjects-qVerified-kymz1 svg { width: 14px; height: 14px; }

.MyProjects-qTotalWrap-ddFNb { text-align: right; -ms-flex-negative: 0; flex-shrink: 0; }

.MyProjects-qTotal-eiiCW { display: block; font-size: 24px; font-weight: 800; line-height: 1; }

.MyProjects-qTotalLabel-IoQ6I { font-size: 11.5px; color: var(--muted); font-weight: 700; }

.MyProjects-qFacts-h1U9o {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px 14px;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
  padding: 14px 0;
}

.MyProjects-qFact-a9c_y { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 2px; }

.MyProjects-qFactLabel-OmMLh { font-size: 12px; color: var(--muted); font-weight: 700; }

.MyProjects-qFactVal-_D0DL { font-size: 14.5px; font-weight: 800; }

.MyProjects-qLines-cyuUH { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 6px; }

.MyProjects-qLinesTitle-rhj7O {
  font-size: 12px; font-weight: 800; text-transform: uppercase;
  letter-spacing: .04em; color: var(--muted); margin-bottom: 2px;
}

.MyProjects-qLineRow-RdibO { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; gap: 12px; font-size: 13.5px; }

.MyProjects-qLineDesc-ptUyg { color: #2a2f34; font-weight: 600; }

.MyProjects-qLineAmt-nMHXu { font-weight: 700; white-space: nowrap; }

.MyProjects-qLineMore-lUZq1 { font-size: 12.5px; color: var(--muted); font-weight: 700; margin-top: 2px; }

.MyProjects-qTotalsRow-SoP7g {
  border-top: 1px solid var(--line);
  padding-top: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-orient: vertical; -webkit-box-direction: normal; -ms-flex-direction: column; flex-direction: column; gap: 4px;
}

.MyProjects-qSub-biLbh { display: -webkit-box; display: -ms-flexbox; display: flex; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; font-size: 13px; color: var(--muted); font-weight: 600; }

.MyProjects-qSubs-Td8tJ { font-size: 12.5px; color: var(--muted); margin: 0; font-style: italic; line-height: 1.4; }

/* E4 — escrow protection indicator + total-you-pay (client-facing) */

.MyProjects-escrowRow-Y6iju {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 10px; -ms-flex-wrap: wrap; flex-wrap: wrap;
  margin: 2px 0;
}

.MyProjects-escrowBadge-bA89r {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 6px;
  font-size: 12px; font-weight: 800; letter-spacing: .02em;
  padding: 6px 12px; border-radius: 999px;
  background: #e7f8ee; color: var(--green);
}

.MyProjects-escrowBadge-bA89r svg { width: 14px; height: 14px; }

.MyProjects-escrowMode-xMLrG { font-size: 12.5px; color: var(--muted); font-weight: 600; line-height: 1.4; }

.MyProjects-payRow-Awtxy {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between;
  gap: 12px; margin-top: 2px; padding: 12px 14px;
  background: var(--bg); border-radius: 12px;
}

.MyProjects-payLabel-jVQ_U { font-size: 13px; font-weight: 700; color: var(--muted); }

.MyProjects-payVal-U2oGD { font-size: 18px; font-weight: 800; color: var(--ink); }

.MyProjects-qActions-IBTQ3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: justify; -ms-flex-pack: justify; justify-content: space-between; gap: 10px;
  margin-top: 2px;
}

.MyProjects-qActions-IBTQ3 .MyProjects-btn-I4tlV { -webkit-box-flex: 1; -ms-flex: 1 1; flex: 1 1; }

.MyProjects-confirmBox-DARmw {
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 14px;
}

.MyProjects-confirmText-oVUvH { font-size: 13.5px; color: #2a2f34; line-height: 1.5; margin: 0 0 12px; }

/* ACCEPTED STATE */

.MyProjects-acceptedCard-NUilq {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 36px 28px;
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
}

.MyProjects-acceptedIcon-BgDRK {
  width: 56px; height: 56px; border-radius: 50%;
  background: #e7f8ee; color: var(--green);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; -webkit-box-pack: center; -ms-flex-pack: center; justify-content: center;
  margin: 0 auto 14px;
}

.MyProjects-acceptedIcon-BgDRK svg { width: 30px; height: 30px; }

.MyProjects-acceptedTitle-GVMue { font-size: 26px; font-weight: 800; margin: 0 0 10px; }

.MyProjects-acceptedText-Bno_h { font-size: 15px; color: var(--muted); line-height: 1.6; margin: 0 0 22px; }

.MyProjects-revealBox-QpTY2 {
  background: var(--bg);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
  margin: 0 0 18px;
}

.MyProjects-revealLabel-JjZjk { display: block; font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: .04em; color: var(--muted); }

.MyProjects-revealName-bLgT4 { display: block; font-size: 18px; font-weight: 800; margin-top: 4px; }

.MyProjects-revealSubs-cxAeO { margin-top: 14px; }

.MyProjects-revealSubsTitle-ekV9P { font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: .04em; color: var(--muted); }

.MyProjects-revealSubsList-fDdz0 { margin: 6px 0 0; padding-left: 18px; font-size: 14px; font-weight: 600; line-height: 1.5; }

.MyProjects-nextSteps-qMAc_ {
  background: #fff8e6;
  border: 1px solid #f1deb0;
  border-radius: 14px;
  padding: 16px 20px;
  text-align: left;
  margin: 0 0 6px;
}

.MyProjects-nextTitle-tJPY7 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex; -webkit-box-align: center; -ms-flex-align: center; align-items: center; gap: 7px;
  font-size: 14px; font-weight: 800; color: #92611a;
}

.MyProjects-nextTitle-tJPY7 svg { width: 18px; height: 18px; }

.MyProjects-nextBody-X1V7O { font-size: 13.5px; color: #6b5418; line-height: 1.55; margin: 8px 0 0; }

/* AUTH GATE */

.MyProjects-authPanel-yrcou {
  background: #fff;
  border: 1px solid var(--line);
  border-radius: 20px;
  padding: 34px 32px;
  max-width: 560px;
  margin: 24px auto;
}

.MyProjects-authTitle-nUYwn { font-size: 26px; font-weight: 800; margin: 8px 0 8px; line-height: 1.15; }

.MyProjects-authHint-Uxuq5 { font-size: 14.5px; color: var(--muted); line-height: 1.6; margin: 0 0 20px; }

.MyProjects-authActions-iQqSF { display: -webkit-box; display: -ms-flexbox; display: flex; gap: 10px; -webkit-box-pack: end; -ms-flex-pack: end; justify-content: flex-end; margin-top: 18px; }

.MyProjects-authFoot-YN_s0 { font-size: 13.5px; color: var(--muted); margin: 14px 0 0; }

.MyProjects-authFoot-YN_s0 a, .MyProjects-nextBody-X1V7O a { color: var(--red); font-weight: 700; text-decoration: none; }

.MyProjects-twoCol-iYNhe { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

.MyProjects-fieldLabel-Azsb1 { font-size: 13px; font-weight: 700; color: var(--muted); margin: 0 0 6px; }

.MyProjects-input-APnuG {
  width: 100%;
  border: 1px solid var(--line);
  border-radius: 10px;
  padding: 10px 12px;
  font: inherit;
  font-size: 14px;
  background: #fff;
  color: var(--ink);
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}

.MyProjects-input-APnuG:focus { outline: none; border-color: var(--red); -webkit-box-shadow: 0 0 0 3px rgba(232,35,43,.12); box-shadow: 0 0 0 3px rgba(232,35,43,.12); }

.MyProjects-codeInput-i5zWN { letter-spacing: .3em; font-weight: 800; text-align: center; max-width: 200px; }

@media (max-width: 880px) {
  .MyProjects-compareHead-JIZ0x { -webkit-box-align: start; -ms-flex-align: start; align-items: flex-start; }
  .MyProjects-qActions-IBTQ3 { -ms-flex-wrap: wrap; flex-wrap: wrap; }
}

@media (max-width: 560px) {
  .MyProjects-wrap-RXCJs { padding: 0 16px; }
  .MyProjects-twoCol-iYNhe { grid-template-columns: 1fr; }
  .MyProjects-qFacts-h1U9o { grid-template-columns: 1fr 1fr; }
  /* Single-column on phones so 320px-min cards never overflow the viewport. */
  .MyProjects-grid-j2laI,
  .MyProjects-compareGrid-gGVdS { grid-template-columns: 1fr; }
  .MyProjects-qHead-XzQoG { -ms-flex-wrap: wrap; flex-wrap: wrap; }
  .MyProjects-qTotalWrap-ddFNb { text-align: left; }
  .MyProjects-acceptedCard-NUilq { padding: 28px 18px; }
  .MyProjects-authPanel-yrcou { padding: 26px 20px; }
  .MyProjects-authActions-iQqSF { -ms-flex-wrap: wrap; flex-wrap: wrap; }
  .MyProjects-authActions-iQqSF .MyProjects-btn-I4tlV,
  .MyProjects-authActions-iQqSF .MyProjects-btnGhost-xi7Qr { -webkit-box-flex: 1; -ms-flex: 1 1; flex: 1 1; }
}

/* BNPL/wallet deposit redirect confirmation banner */

.MyProjects-depositReturnBanner-VMVRi {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  background: #ecfdf3;
  border: 1px solid #abefc6;
  color: #067647;
  border-radius: 12px;
  padding: 13px 16px;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 18px;
}

.MyProjects-depositReturnBanner-VMVRi svg { width: 20px; height: 20px; -webkit-box-flex: 0; -ms-flex: none; flex: none; }
`, "",{"version":3,"sources":["webpack://./src/routes/my-projects/MyProjects.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,uFAAuF;EACvF,cAAiB;EAAjB,iBAAiB;EACjB,mBAAqB;EAArB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;;AACZ;EACE,gBAAgB;EAChB,oCAAoC;EACpC,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AACA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAe;MAAf,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,yBAAQ,oBAAoB,EAAE;;AAE9B,qDAAqD;;AACrD;EACE,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,iCAAgB,eAAe,EAAE;;AACjC;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,4BAA4B;EAC5B,+DAAsC;UAAtC,uDAAsC;AACxC;;AACA;EACE,KAAK,iCAAyB,EAAzB,yBAAyB,EAAE;AAClC;;AAFA;EACE,KAAK,iCAAyB,EAAzB,yBAAyB,EAAE;AAClC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,mBAAe;MAAf,eAAe;AACjB;;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yBAAyB;;AACzB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;EACT,sFAA8D;EAA9D,8EAA8D;EAA9D,8DAA8D;EAA9D,+GAA8D;EAC9D,aAAa;EACb,cAAc;AAChB;;AACA;EACE,sDAA8C;UAA9C,8CAA8C;EAC9C,mCAA2B;MAA3B,+BAA2B;UAA3B,2BAA2B;EAC3B,qBAAqB;AACvB;;AACA,4BAAW,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,QAAQ,EAAE;;AACzF;EACE,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AACA;+EAC+E;;AAC/E;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,0BAAsB;MAAtB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,wBAAwB;AAC1B;;AACA,8BAAa,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE,iBAAiB,EAAE;;AAC9E,gCAAe,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,mBAAe,EAAf,eAAe,EAAE,SAAS,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE;;AAC/E;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AACA,iCAAgB,WAAW,EAAE,YAAY,EAAE,iBAAiB,EAAE,YAAY,EAAE;;AAC5E;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,iCAAiC;EACjC,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AACA,4BAAW,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,2BAAoB,EAApB,2BAAoB,EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ,EAAE;;AAC1H,gCAAe,WAAW,EAAE,YAAY,EAAE,YAAY,EAAE;;AACxD,4BAAW,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEjE,mCAAmC;;AACnC;EACE,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB;EAC1D,iBAAiB,EAAE,oBAAoB;EACvC,qBAAqB,EAAE,mBAAmB;EAC1C,yBAAyB;EACzB,mBAAmB;AACrB;;AACA,6BAAY,mBAAmB,EAAE,cAAc,EAAE;;AACjD,8DAA4B,mBAAmB,EAAE,cAAc,EAAE;;AACjE,gCAAe,mBAAmB,EAAE,mBAAmB,EAAE;;AACzD,kCAAiB,mBAAmB,EAAE,kBAAkB,EAAE;;AAC1D,8BAAa,mBAAmB,EAAE,cAAc,EAAE;;AAClD,iCAAgB,mBAAmB,EAAE,mBAAmB,EAAE;;AAE1D,gBAAgB;;AAChB;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AACA,6BAAY,YAAY,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE;;AAC7E,+BAAc,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAClE,8BAAa,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,cAAc,EAAE,iBAAiB,EAAE;;AAExG,WAAW;;AACX;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AACA,6BAAY,mBAAmB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE;;AACjF,gCAAe,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE/E,YAAY;;AACZ;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,mCAA2B;EAA3B,2BAA2B;AAC7B;;AACA,8BAAa,wBAAwB,EAAE;;AACvC,iCAAgB,YAAY,EAAE,eAAe,EAAE;;AAC/C;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;AACvB;;AACA,mCAAkB,qBAAqB,EAAE;;AACzC,sCAAqB,YAAY,EAAE,eAAe,EAAE;;AACpD;EACE,gBAAgB,EAAE,YAAY,EAAE,mBAAmB;EACnD,gBAAgB,EAAE,eAAe,EAAE,eAAe;EAClD,gBAAgB;AAClB;;AACA,kCAAiB,iBAAiB,EAAE;;AACpC,qCAAoB,YAAY,EAAE,eAAe,EAAE;;AAEnD;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AACA,kCAAiB,iBAAiB,EAAE;;AACpC,gCAAe,WAAW,EAAE,YAAY,EAAE;;AAE1C,gBAAgB;;AAChB,+BAAc,mBAAmB,EAAE;;AACnC,yDAAuB,mBAAmB,EAAE;;AAC5C;EACE,eAAe,EAAE,cAAc,EAAE,gBAAgB;EACjD,gBAAgB,EAAE,gBAAgB,EAAE,qBAAqB;AAC3D;;AACA,gCAAe,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,mBAAe,EAAf,eAAe,EAAE,QAAQ,EAAE,gBAAgB,EAAE;;AAC3E;EACE,gBAAgB,EAAE,6BAA6B,EAAE,oBAAoB;EACrE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,mBAAmB;AAC3E;;AAEA,iBAAiB;;AACjB;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,gBAAgB;AAClB;;AACA,iCAAgB,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AACpE;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB,EAAE,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB,EAAE,QAAQ;EACvD,eAAe,EAAE,mBAAmB,EAAE,SAAS,EAAE,gBAAgB;EACjE,gBAAgB;AAClB;;AACA,oCAAmB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,oBAAc,EAAd,cAAc,EAAE,eAAe,EAAE;;AACnG,4BAAW,2BAAoB,EAApB,2BAAoB,EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ,EAAE;;AAChE,8BAAa,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AACrE;EACE,6BAA6B,EAAE,mBAAmB;EAClD,iBAAiB,EAAE,aAAa,EAAE,eAAe,EAAE,gBAAgB;EACnE,gBAAgB,EAAE,iBAAiB,EAAE,eAAe;AACtD;;AACA,qCAAoB,aAAa,EAAE,wBAAwB,EAAE,iDAAyC,EAAzC,yCAAyC,EAAE;;AAExG,+BAA+B;;AAC/B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;AACpB;;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,SAAS;AACX;;AACA,kCAAiB,0BAA0B,EAAE,mDAA2C,EAA3C,2CAA2C,EAAE;;AAC1F;EACE,kBAAkB,EAAE,UAAU,EAAE,UAAU;EAC1C,wBAAwB,EAAE,WAAW;EACrC,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,iBAAiB,EAAE,oBAAoB,EAAE,yBAAyB;AACpE;;AAEA,0BAAS,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,SAAS,EAAE;;AAC5F,6BAAY,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,SAAS,EAAE;;AAC3D;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB;EAC9C,mBAAmB,EAAE,iBAAiB;EACtC,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB;EAClE,oBAAc;MAAd,cAAc;AAChB;;AACA,gCAAe,WAAW,EAAE,YAAY,EAAE;;AAC1C,iCAAgB,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AACvF;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ;EACnD,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,eAAe;AACzE;;AACA,kCAAiB,WAAW,EAAE,YAAY,EAAE;;AAC5C,+BAAc,iBAAiB,EAAE,oBAAc,EAAd,cAAc,EAAE;;AACjD,2BAAU,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;;AAC7E,gCAAe,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAEzE;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iCAAiC;EACjC,oCAAoC;EACpC,eAAe;AACjB;;AACA,0BAAS,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ,EAAE;;AAC1D,+BAAc,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACtE,6BAAY,iBAAiB,EAAE,gBAAgB,EAAE;;AAEjD,2BAAU,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ,EAAE;;AAC3D;EACE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB;EAC5D,qBAAqB,EAAE,mBAAmB,EAAE,kBAAkB;AAChE;;AACA,6BAAY,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,SAAS,EAAE,iBAAiB,EAAE;;AACzF,8BAAa,cAAc,EAAE,gBAAgB,EAAE;;AAC/C,6BAAY,gBAAgB,EAAE,mBAAmB,EAAE;;AACnD,8BAAa,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAExF;EACE,iCAAiC;EACjC,iBAAiB;EACjB,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,4BAAsB,EAAtB,6BAAsB,EAAtB,0BAAsB,EAAtB,sBAAsB,EAAE,QAAQ;AACjD;;AACA,yBAAQ,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAE/G,0BAAS,iBAAiB,EAAE,mBAAmB,EAAE,SAAS,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAElG,qEAAqE;;AACrE;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,SAAS,EAAE,mBAAe,EAAf,eAAe;EAC9D,aAAa;AACf;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ;EACnD,eAAe,EAAE,gBAAgB,EAAE,qBAAqB;EACxD,iBAAiB,EAAE,oBAAoB;EACvC,mBAAmB,EAAE,mBAAmB;AAC1C;;AACA,oCAAmB,WAAW,EAAE,YAAY,EAAE;;AAC9C,+BAAc,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAC1F;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B;EAClE,SAAS,EAAE,eAAe,EAAE,kBAAkB;EAC9C,qBAAqB,EAAE,mBAAmB;AAC5C;;AACA,6BAAY,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;;AACpE,2BAAU,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEhE;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,yBAA8B,EAA9B,sBAA8B,EAA9B,8BAA8B,EAAE,SAAS;EAC7E,eAAe;AACjB;;AACA,mDAAiB,mBAAO,EAAP,aAAO,EAAP,SAAO,EAAE;;AAE1B;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;AACf;;AACA,gCAAe,iBAAiB,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAEtF,mBAAmB;;AACnB;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AACA;EACE,WAAW,EAAE,YAAY,EAAE,kBAAkB;EAC7C,mBAAmB,EAAE,mBAAmB;EACxC,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB;EAClE,mBAAmB;AACrB;;AACA,qCAAoB,WAAW,EAAE,YAAY,EAAE;;AAC/C,kCAAiB,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AACtE,iCAAgB,eAAe,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAE1F;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AACA,gCAAe,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;;AACzI,+BAAc,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAClF,+BAAc,gBAAgB,EAAE;;AAChC,oCAAmB,eAAe,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;;AAC7H,mCAAkB,eAAe,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AAE5G;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AACA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB,EAAE,yBAAmB,EAAnB,sBAAmB,EAAnB,mBAAmB,EAAE,QAAQ;EACnD,eAAe,EAAE,gBAAgB,EAAE,cAAc;AACnD;;AACA,kCAAiB,WAAW,EAAE,YAAY,EAAE;;AAC5C,6BAAY,iBAAiB,EAAE,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;;AAEnF,cAAc;;AACd;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AACA,8BAAa,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;;AACtF,6BAAY,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;;AACxF,gCAAe,oBAAa,EAAb,oBAAa,EAAb,aAAa,EAAE,SAAS,EAAE,qBAAyB,EAAzB,kBAAyB,EAAzB,yBAAyB,EAAE,gBAAgB,EAAE;;AACtF,6BAAY,iBAAiB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AACtE,6DAA2B,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;;AAEvF,2BAAU,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE;;AACpE,+BAAc,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,eAAe,EAAE;;AACvF;EACE,WAAW;EACX,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,8BAAsB;UAAtB,sBAAsB;AACxB;;AACA,gCAAe,aAAa,EAAE,wBAAwB,EAAE,iDAAyC,EAAzC,yCAAyC,EAAE;;AACnG,8BAAa,oBAAoB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;;AAE3F;EACE,gCAAe,wBAAuB,EAAvB,qBAAuB,EAAvB,uBAAuB,EAAE;EACxC,6BAAY,mBAAe,EAAf,eAAe,EAAE;AAC/B;;AAEA;EACE,yBAAQ,eAAe,EAAE;EACzB,2BAAU,0BAA0B,EAAE;EACtC,2BAAU,8BAA8B,EAAE;EAC1C,4EAA4E;EAC5E;kCACe,0BAA0B,EAAE;EAC3C,0BAAS,mBAAe,EAAf,eAAe,EAAE;EAC1B,+BAAc,gBAAgB,EAAE;EAChC,iCAAgB,kBAAkB,EAAE;EACpC,8BAAa,kBAAkB,EAAE;EACjC,gCAAe,mBAAe,EAAf,eAAe,EAAE;EAChC;6DACyB,mBAAO,EAAP,aAAO,EAAP,SAAO,EAAE;AACpC;;AAEA,qDAAqD;;AACrD;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AACA,4CAA2B,WAAW,EAAE,YAAY,EAAE,mBAAU,EAAV,cAAU,EAAV,UAAU,EAAE","sourcesContent":[".page {\n  --red: #e8232b;\n  --red-d: #c2151c;\n  --ink: #0f1214;\n  --muted: #5a6168;\n  --line: #e7e9ec;\n  --bg: #f7f8f9;\n  --green: #16a34a;\n  --teal: #0f766e;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  color: var(--ink);\n  background: var(--bg);\n  min-height: 100vh;\n}\n\n.wrap {\n  max-width: 1080px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n/* TOP BAR */\n.topbar {\n  background: #fff;\n  border-bottom: 1px solid var(--line);\n  position: sticky;\n  top: 0;\n  z-index: 20;\n}\n.brandRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 16px 0;\n}\n.eyebrow {\n  display: inline-block;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--red);\n}\n\n.body { padding: 28px 0 64px; }\n\n/* LOADING (branded spinner — never a blank screen) */\n.loading {\n  padding: 56px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  color: var(--muted);\n  font-weight: 700;\n}\n.loadingLabel { font-size: 14px; }\n.spinner {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: 3px solid #f0d6d7;\n  border-top-color: var(--red);\n  animation: mpSpin 0.7s linear infinite;\n}\n@keyframes mpSpin {\n  to { transform: rotate(360deg); }\n}\n\n.headRow {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n  flex-wrap: wrap;\n}\n.h1 {\n  font-size: clamp(24px, 3.6vw, 34px);\n  line-height: 1.1;\n  font-weight: 800;\n  margin: 0 0 6px;\n}\n.sub {\n  font-size: 15px;\n  color: var(--muted);\n  margin: 0;\n  line-height: 1.55;\n  max-width: 640px;\n}\n\n/* GRID + PROJECT CARDS */\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 18px;\n}\n.card {\n  text-align: left;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 18px 20px;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  transition: box-shadow .15s, transform .15s, border-color .15s;\n  font: inherit;\n  color: inherit;\n}\n.card:hover {\n  box-shadow: 0 14px 34px rgba(15, 18, 20, 0.10);\n  transform: translateY(-2px);\n  border-color: #d7dadf;\n}\n.cardTop { display: flex; align-items: center; justify-content: space-between; gap: 8px; }\n.catPill {\n  display: inline-block;\n  background: #fff0ef;\n  color: var(--red-d);\n  font-weight: 800;\n  font-size: 12px;\n  letter-spacing: .02em;\n  padding: 5px 12px;\n  border-radius: 999px;\n}\n/* RECEIVED-QUOTES BADGE — prominent pill on each project card; shown only N>0.\n   The actionable \"N quotes received\" counter that increments as pros submit. */\n.quotesBadge {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  gap: 6px;\n  margin: 2px 0 0;\n  background: #e7f8ee;\n  color: var(--green);\n  font-weight: 800;\n  font-size: 12px;\n  letter-spacing: .02em;\n  padding: 5px 12px;\n  border-radius: 999px;\n}\n.quotesBadge::before {\n  content: '';\n  width: 7px;\n  height: 7px;\n  border-radius: 999px;\n  background: var(--green);\n}\n.cardTitle { font-size: 18px; font-weight: 800; margin: 0; line-height: 1.25; }\n.cardMetaRow { display: flex; flex-wrap: wrap; gap: 14px; align-items: center; }\n.cardMeta {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13.5px;\n  color: var(--muted);\n  font-weight: 600;\n}\n.cardMeta svg { width: 16px; height: 16px; color: var(--ink); opacity: .55; }\n.cardFoot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid var(--line);\n  padding-top: 12px;\n  margin-top: 2px;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.cardRef { font-size: 12.5px; color: var(--muted); font-weight: 700; display: inline-flex; align-items: center; gap: 6px; }\n.cardRef svg { width: 15px; height: 15px; opacity: .55; }\n.cardCta { font-size: 14px; font-weight: 800; color: var(--red); }\n\n/* STATUS PILLS (project + quote) */\n.statusPill {\n  font-size: 11.5px; font-weight: 800; letter-spacing: .03em;\n  padding: 5px 11px; border-radius: 999px;\n  background: var(--bg); color: var(--muted);\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n.st_draft { background: #eef0f2; color: #5a6168; }\n.st_published, .st_quoted { background: #e7f0ff; color: #1d4ed8; }\n.st_selected { background: #e7f8ee; color: var(--green); }\n.st_contracted { background: #e7f8ee; color: var(--teal); }\n.st_closed { background: #eef0f2; color: #5a6168; }\n.st_cancelled { background: #fff0ef; color: var(--red-d); }\n\n/* EMPTY STATE */\n.empty {\n  background: #fff;\n  border: 1px dashed #d7dadf;\n  border-radius: 20px;\n  padding: 48px 24px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.emptyImg { width: 120px; height: auto; margin: 0 auto 12px; display: block; }\n.emptyTitle { font-size: 20px; font-weight: 800; margin: 0 0 8px; }\n.emptyBody { font-size: 15px; color: var(--muted); max-width: 440px; margin: 0 auto; line-height: 1.55; }\n\n/* ALERTS */\n.alertErr, .alertNotice {\n  border-radius: 12px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  margin: 0 0 16px;\n  line-height: 1.45;\n}\n.alertErr { background: #fff0ef; color: var(--red-d); border: 1px solid #f6c9c7; }\n.alertNotice { background: #eef6ff; color: #1d4ed8; border: 1px solid #cfe0fb; }\n\n/* BUTTONS */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--red);\n  color: #fff;\n  border: none;\n  font-weight: 800;\n  font-size: 15px;\n  padding: 12px 22px;\n  border-radius: 12px;\n  cursor: pointer;\n  text-decoration: none;\n  transition: background .15s;\n}\n.btn:hover { background: var(--red-d); }\n.btn:disabled { opacity: .55; cursor: default; }\n.btnGhost {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  color: var(--ink);\n  border: 1px solid var(--line);\n  font-weight: 800;\n  font-size: 14px;\n  padding: 10px 18px;\n  border-radius: 12px;\n  cursor: pointer;\n  text-decoration: none;\n}\n.btnGhost:hover { border-color: #c9ccd1; }\n.btnGhost:disabled { opacity: .55; cursor: default; }\n.linkBtn {\n  background: none; border: none; color: var(--muted);\n  font-weight: 700; font-size: 14px; cursor: pointer;\n  padding: 6px 8px;\n}\n.linkBtn:hover { color: var(--ink); }\n.linkBtn:disabled { opacity: .55; cursor: default; }\n\n.backBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: var(--muted);\n  font-weight: 700;\n  font-size: 14px;\n  cursor: pointer;\n  padding: 4px 0;\n  margin-bottom: 14px;\n}\n.backBtn:hover { color: var(--ink); }\n.backBtn svg { width: 18px; height: 18px; }\n\n/* DETAIL HEAD */\n.detailHead { margin-bottom: 22px; }\n.detailHead .catPill { margin-bottom: 10px; }\n.detailScope {\n  font-size: 15px; color: #2a2f34; line-height: 1.6;\n  margin: 12px 0 0; max-width: 760px; white-space: pre-line;\n}\n.detailFacts { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 14px; }\n.factChip {\n  background: #fff; border: 1px solid var(--line); border-radius: 999px;\n  padding: 6px 12px; font-size: 13px; font-weight: 700; color: var(--muted);\n}\n\n/* COMPARE HEAD */\n.compareHead {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin: 0 0 18px;\n}\n.compareTitle { font-size: 22px; font-weight: 800; margin: 0 0 6px; }\n.privacyNote {\n  display: inline-flex; align-items: flex-start; gap: 7px;\n  font-size: 13px; color: var(--muted); margin: 0; line-height: 1.5;\n  max-width: 560px;\n}\n.privacyNote svg { width: 16px; height: 16px; color: var(--teal); flex-shrink: 0; margin-top: 1px; }\n.sortRow { display: inline-flex; align-items: center; gap: 8px; }\n.sortLabel { font-size: 13px; font-weight: 700; color: var(--muted); }\n.sortSelect {\n  border: 1px solid var(--line); border-radius: 10px;\n  padding: 9px 12px; font: inherit; font-size: 14px; font-weight: 700;\n  background: #fff; color: var(--ink); cursor: pointer;\n}\n.sortSelect:focus { outline: none; border-color: var(--red); box-shadow: 0 0 0 3px rgba(232,35,43,.12); }\n\n/* COMPARE GRID + QUOTE CARDS */\n.compareGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 18px;\n  align-items: start;\n}\n.quoteCard {\n  position: relative;\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 18px;\n  padding: 20px 20px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n.quoteCardBest { border-color: var(--green); box-shadow: 0 10px 26px rgba(22,163,74,.10); }\n.bestBadge {\n  position: absolute; top: -11px; left: 18px;\n  background: var(--green); color: #fff;\n  font-size: 11px; font-weight: 800; letter-spacing: .03em;\n  padding: 4px 11px; border-radius: 999px; text-transform: uppercase;\n}\n\n.qHead { display: flex; align-items: flex-start; justify-content: space-between; gap: 12px; }\n.qCompany { display: flex; align-items: center; gap: 12px; }\n.qAvatar {\n  width: 42px; height: 42px; border-radius: 12px;\n  background: #fff0ef; color: var(--red);\n  display: inline-flex; align-items: center; justify-content: center;\n  flex-shrink: 0;\n}\n.qAvatar svg { width: 22px; height: 22px; }\n.qCompanyName { display: block; font-size: 15.5px; font-weight: 800; line-height: 1.2; }\n.qVerified {\n  display: inline-flex; align-items: center; gap: 4px;\n  font-size: 12px; font-weight: 700; color: var(--green); margin-top: 2px;\n}\n.qVerified svg { width: 14px; height: 14px; }\n.qTotalWrap { text-align: right; flex-shrink: 0; }\n.qTotal { display: block; font-size: 24px; font-weight: 800; line-height: 1; }\n.qTotalLabel { font-size: 11.5px; color: var(--muted); font-weight: 700; }\n\n.qFacts {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px 14px;\n  border-top: 1px solid var(--line);\n  border-bottom: 1px solid var(--line);\n  padding: 14px 0;\n}\n.qFact { display: flex; flex-direction: column; gap: 2px; }\n.qFactLabel { font-size: 12px; color: var(--muted); font-weight: 700; }\n.qFactVal { font-size: 14.5px; font-weight: 800; }\n\n.qLines { display: flex; flex-direction: column; gap: 6px; }\n.qLinesTitle {\n  font-size: 12px; font-weight: 800; text-transform: uppercase;\n  letter-spacing: .04em; color: var(--muted); margin-bottom: 2px;\n}\n.qLineRow { display: flex; justify-content: space-between; gap: 12px; font-size: 13.5px; }\n.qLineDesc { color: #2a2f34; font-weight: 600; }\n.qLineAmt { font-weight: 700; white-space: nowrap; }\n.qLineMore { font-size: 12.5px; color: var(--muted); font-weight: 700; margin-top: 2px; }\n\n.qTotalsRow {\n  border-top: 1px solid var(--line);\n  padding-top: 10px;\n  display: flex; flex-direction: column; gap: 4px;\n}\n.qSub { display: flex; justify-content: space-between; font-size: 13px; color: var(--muted); font-weight: 600; }\n\n.qSubs { font-size: 12.5px; color: var(--muted); margin: 0; font-style: italic; line-height: 1.4; }\n\n/* E4 — escrow protection indicator + total-you-pay (client-facing) */\n.escrowRow {\n  display: flex; align-items: center; gap: 10px; flex-wrap: wrap;\n  margin: 2px 0;\n}\n.escrowBadge {\n  display: inline-flex; align-items: center; gap: 6px;\n  font-size: 12px; font-weight: 800; letter-spacing: .02em;\n  padding: 6px 12px; border-radius: 999px;\n  background: #e7f8ee; color: var(--green);\n}\n.escrowBadge svg { width: 14px; height: 14px; }\n.escrowMode { font-size: 12.5px; color: var(--muted); font-weight: 600; line-height: 1.4; }\n.payRow {\n  display: flex; align-items: center; justify-content: space-between;\n  gap: 12px; margin-top: 2px; padding: 12px 14px;\n  background: var(--bg); border-radius: 12px;\n}\n.payLabel { font-size: 13px; font-weight: 700; color: var(--muted); }\n.payVal { font-size: 18px; font-weight: 800; color: var(--ink); }\n\n.qActions {\n  display: flex; align-items: center; justify-content: space-between; gap: 10px;\n  margin-top: 2px;\n}\n.qActions .btn { flex: 1; }\n\n.confirmBox {\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 12px;\n  padding: 14px;\n}\n.confirmText { font-size: 13.5px; color: #2a2f34; line-height: 1.5; margin: 0 0 12px; }\n\n/* ACCEPTED STATE */\n.acceptedCard {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 36px 28px;\n  max-width: 640px;\n  margin: 0 auto;\n  text-align: center;\n}\n.acceptedIcon {\n  width: 56px; height: 56px; border-radius: 50%;\n  background: #e7f8ee; color: var(--green);\n  display: inline-flex; align-items: center; justify-content: center;\n  margin: 0 auto 14px;\n}\n.acceptedIcon svg { width: 30px; height: 30px; }\n.acceptedTitle { font-size: 26px; font-weight: 800; margin: 0 0 10px; }\n.acceptedText { font-size: 15px; color: var(--muted); line-height: 1.6; margin: 0 0 22px; }\n\n.revealBox {\n  background: var(--bg);\n  border: 1px solid var(--line);\n  border-radius: 14px;\n  padding: 18px 20px;\n  text-align: left;\n  margin: 0 0 18px;\n}\n.revealLabel { display: block; font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: .04em; color: var(--muted); }\n.revealName { display: block; font-size: 18px; font-weight: 800; margin-top: 4px; }\n.revealSubs { margin-top: 14px; }\n.revealSubsTitle { font-size: 12px; font-weight: 800; text-transform: uppercase; letter-spacing: .04em; color: var(--muted); }\n.revealSubsList { margin: 6px 0 0; padding-left: 18px; font-size: 14px; font-weight: 600; line-height: 1.5; }\n\n.nextSteps {\n  background: #fff8e6;\n  border: 1px solid #f1deb0;\n  border-radius: 14px;\n  padding: 16px 20px;\n  text-align: left;\n  margin: 0 0 6px;\n}\n.nextTitle {\n  display: inline-flex; align-items: center; gap: 7px;\n  font-size: 14px; font-weight: 800; color: #92611a;\n}\n.nextTitle svg { width: 18px; height: 18px; }\n.nextBody { font-size: 13.5px; color: #6b5418; line-height: 1.55; margin: 8px 0 0; }\n\n/* AUTH GATE */\n.authPanel {\n  background: #fff;\n  border: 1px solid var(--line);\n  border-radius: 20px;\n  padding: 34px 32px;\n  max-width: 560px;\n  margin: 24px auto;\n}\n.authTitle { font-size: 26px; font-weight: 800; margin: 8px 0 8px; line-height: 1.15; }\n.authHint { font-size: 14.5px; color: var(--muted); line-height: 1.6; margin: 0 0 20px; }\n.authActions { display: flex; gap: 10px; justify-content: flex-end; margin-top: 18px; }\n.authFoot { font-size: 13.5px; color: var(--muted); margin: 14px 0 0; }\n.authFoot a, .nextBody a { color: var(--red); font-weight: 700; text-decoration: none; }\n\n.twoCol { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }\n.fieldLabel { font-size: 13px; font-weight: 700; color: var(--muted); margin: 0 0 6px; }\n.input {\n  width: 100%;\n  border: 1px solid var(--line);\n  border-radius: 10px;\n  padding: 10px 12px;\n  font: inherit;\n  font-size: 14px;\n  background: #fff;\n  color: var(--ink);\n  box-sizing: border-box;\n}\n.input:focus { outline: none; border-color: var(--red); box-shadow: 0 0 0 3px rgba(232,35,43,.12); }\n.codeInput { letter-spacing: .3em; font-weight: 800; text-align: center; max-width: 200px; }\n\n@media (max-width: 880px) {\n  .compareHead { align-items: flex-start; }\n  .qActions { flex-wrap: wrap; }\n}\n\n@media (max-width: 560px) {\n  .wrap { padding: 0 16px; }\n  .twoCol { grid-template-columns: 1fr; }\n  .qFacts { grid-template-columns: 1fr 1fr; }\n  /* Single-column on phones so 320px-min cards never overflow the viewport. */\n  .grid,\n  .compareGrid { grid-template-columns: 1fr; }\n  .qHead { flex-wrap: wrap; }\n  .qTotalWrap { text-align: left; }\n  .acceptedCard { padding: 28px 18px; }\n  .authPanel { padding: 26px 20px; }\n  .authActions { flex-wrap: wrap; }\n  .authActions .btn,\n  .authActions .btnGhost { flex: 1; }\n}\n\n/* BNPL/wallet deposit redirect confirmation banner */\n.depositReturnBanner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #ecfdf3;\n  border: 1px solid #abefc6;\n  color: #067647;\n  border-radius: 12px;\n  padding: 13px 16px;\n  font-size: 14px;\n  font-weight: 700;\n  margin-bottom: 18px;\n}\n.depositReturnBanner svg { width: 20px; height: 20px; flex: none; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `MyProjects-page-zQSvr`,
	"wrap": `MyProjects-wrap-RXCJs`,
	"topbar": `MyProjects-topbar-qX3Uw`,
	"brandRow": `MyProjects-brandRow-D9sfk`,
	"eyebrow": `MyProjects-eyebrow-alumW`,
	"body": `MyProjects-body-vEeR7`,
	"loading": `MyProjects-loading-kJv5Q`,
	"loadingLabel": `MyProjects-loadingLabel-lFwqB`,
	"spinner": `MyProjects-spinner-gSLus`,
	"mpSpin": `MyProjects-mpSpin-OPIsB`,
	"headRow": `MyProjects-headRow-U49wz`,
	"h1": `MyProjects-h1-wdPlm`,
	"sub": `MyProjects-sub-qEv4_`,
	"grid": `MyProjects-grid-j2laI`,
	"card": `MyProjects-card-OWdYt`,
	"cardTop": `MyProjects-cardTop-jyx1x`,
	"catPill": `MyProjects-catPill-_t96I`,
	"quotesBadge": `MyProjects-quotesBadge-ONKOV`,
	"cardTitle": `MyProjects-cardTitle-qQcFj`,
	"cardMetaRow": `MyProjects-cardMetaRow-DBcFJ`,
	"cardMeta": `MyProjects-cardMeta-MzpzL`,
	"cardFoot": `MyProjects-cardFoot-emXDS`,
	"cardRef": `MyProjects-cardRef-ZLDlQ`,
	"cardCta": `MyProjects-cardCta-ZTBja`,
	"statusPill": `MyProjects-statusPill-d9ygy`,
	"st_draft": `MyProjects-st_draft-vY5_c`,
	"st_published": `MyProjects-st_published-_MuEL`,
	"st_quoted": `MyProjects-st_quoted-vAfms`,
	"st_selected": `MyProjects-st_selected-ORFy0`,
	"st_contracted": `MyProjects-st_contracted-bnNSf`,
	"st_closed": `MyProjects-st_closed-TnFBu`,
	"st_cancelled": `MyProjects-st_cancelled-HqnUb`,
	"empty": `MyProjects-empty-gs0cA`,
	"emptyImg": `MyProjects-emptyImg-prMGZ`,
	"emptyTitle": `MyProjects-emptyTitle-Dpqw6`,
	"emptyBody": `MyProjects-emptyBody-wxXFA`,
	"alertErr": `MyProjects-alertErr-Zmmu_`,
	"alertNotice": `MyProjects-alertNotice-hejO7`,
	"btn": `MyProjects-btn-I4tlV`,
	"btnGhost": `MyProjects-btnGhost-xi7Qr`,
	"linkBtn": `MyProjects-linkBtn-JTtVP`,
	"backBtn": `MyProjects-backBtn-UqKBC`,
	"detailHead": `MyProjects-detailHead-MMpI4`,
	"detailScope": `MyProjects-detailScope-ikKES`,
	"detailFacts": `MyProjects-detailFacts-Ycn7b`,
	"factChip": `MyProjects-factChip-RGW3F`,
	"compareHead": `MyProjects-compareHead-JIZ0x`,
	"compareTitle": `MyProjects-compareTitle-HUHAF`,
	"privacyNote": `MyProjects-privacyNote-RuDOS`,
	"sortRow": `MyProjects-sortRow-XfyMK`,
	"sortLabel": `MyProjects-sortLabel-sG9pE`,
	"sortSelect": `MyProjects-sortSelect-qzGUe`,
	"compareGrid": `MyProjects-compareGrid-gGVdS`,
	"quoteCard": `MyProjects-quoteCard-cBDFN`,
	"quoteCardBest": `MyProjects-quoteCardBest-XNIe_`,
	"bestBadge": `MyProjects-bestBadge-g3wqx`,
	"qHead": `MyProjects-qHead-XzQoG`,
	"qCompany": `MyProjects-qCompany-cKoEM`,
	"qAvatar": `MyProjects-qAvatar-mJQAI`,
	"qCompanyName": `MyProjects-qCompanyName-yb8xf`,
	"qVerified": `MyProjects-qVerified-kymz1`,
	"qTotalWrap": `MyProjects-qTotalWrap-ddFNb`,
	"qTotal": `MyProjects-qTotal-eiiCW`,
	"qTotalLabel": `MyProjects-qTotalLabel-IoQ6I`,
	"qFacts": `MyProjects-qFacts-h1U9o`,
	"qFact": `MyProjects-qFact-a9c_y`,
	"qFactLabel": `MyProjects-qFactLabel-OmMLh`,
	"qFactVal": `MyProjects-qFactVal-_D0DL`,
	"qLines": `MyProjects-qLines-cyuUH`,
	"qLinesTitle": `MyProjects-qLinesTitle-rhj7O`,
	"qLineRow": `MyProjects-qLineRow-RdibO`,
	"qLineDesc": `MyProjects-qLineDesc-ptUyg`,
	"qLineAmt": `MyProjects-qLineAmt-nMHXu`,
	"qLineMore": `MyProjects-qLineMore-lUZq1`,
	"qTotalsRow": `MyProjects-qTotalsRow-SoP7g`,
	"qSub": `MyProjects-qSub-biLbh`,
	"qSubs": `MyProjects-qSubs-Td8tJ`,
	"escrowRow": `MyProjects-escrowRow-Y6iju`,
	"escrowBadge": `MyProjects-escrowBadge-bA89r`,
	"escrowMode": `MyProjects-escrowMode-xMLrG`,
	"payRow": `MyProjects-payRow-Awtxy`,
	"payLabel": `MyProjects-payLabel-jVQ_U`,
	"payVal": `MyProjects-payVal-U2oGD`,
	"qActions": `MyProjects-qActions-IBTQ3`,
	"confirmBox": `MyProjects-confirmBox-DARmw`,
	"confirmText": `MyProjects-confirmText-oVUvH`,
	"acceptedCard": `MyProjects-acceptedCard-NUilq`,
	"acceptedIcon": `MyProjects-acceptedIcon-BgDRK`,
	"acceptedTitle": `MyProjects-acceptedTitle-GVMue`,
	"acceptedText": `MyProjects-acceptedText-Bno_h`,
	"revealBox": `MyProjects-revealBox-QpTY2`,
	"revealLabel": `MyProjects-revealLabel-JjZjk`,
	"revealName": `MyProjects-revealName-bLgT4`,
	"revealSubs": `MyProjects-revealSubs-cxAeO`,
	"revealSubsTitle": `MyProjects-revealSubsTitle-ekV9P`,
	"revealSubsList": `MyProjects-revealSubsList-fDdz0`,
	"nextSteps": `MyProjects-nextSteps-qMAc_`,
	"nextTitle": `MyProjects-nextTitle-tJPY7`,
	"nextBody": `MyProjects-nextBody-X1V7O`,
	"authPanel": `MyProjects-authPanel-yrcou`,
	"authTitle": `MyProjects-authTitle-nUYwn`,
	"authHint": `MyProjects-authHint-Uxuq5`,
	"authActions": `MyProjects-authActions-iQqSF`,
	"authFoot": `MyProjects-authFoot-YN_s0`,
	"twoCol": `MyProjects-twoCol-iYNhe`,
	"fieldLabel": `MyProjects-fieldLabel-Azsb1`,
	"input": `MyProjects-input-APnuG`,
	"codeInput": `MyProjects-codeInput-i5zWN`,
	"depositReturnBanner": `MyProjects-depositReturnBanner-VMVRi`
};
module.exports = ___CSS_LOADER_EXPORT___;
